module.exports = __webpack_public_path__ + "static/media/visa.32e20beb.svg";